module.exports = __webpack_public_path__ + "img/110.50f63720.jpg";